import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { LocalStorageService } from '../local-storage.service';
import { global } from 'app/utils/global';
import * as i0 from "@angular/core";
import * as i1 from "./auth.service";
import * as i2 from "../local-storage.service";
import * as i3 from "@angular/router";
var AuthGuard = /** @class */ (function () {
    function AuthGuard(authService, localStorageService, router) {
        this.authService = authService;
        this.localStorageService = localStorageService;
        this.router = router;
    }
    /**
     * @author Frank Edward Daza González
     * @version 2018-11-06
     * @param next
     * @param state
     */
    AuthGuard.prototype.canActivate = function (next, state) {
        var usuario = this.authService.getUsuario();
        var cliente;
        var pedido;
        switch (next.data.guards) {
            //Loged in
            case global.GUARDS.NO_AUTH:
                if (!usuario) {
                    return true;
                }
                else {
                    this.router.navigate(['/']);
                    return false;
                }
            case global.GUARDS.AUTH:
                if (usuario) {
                    return true;
                }
                else {
                    this.router.navigate(['/auth/login']);
                    return false;
                }
            //Roles
            case global.GUARDS.VENDEDOR:
                if (usuario && usuario.nombreRol == global.GUARDS.VENDEDOR) {
                    return true;
                }
                break;
            case global.GUARDS.TELEMERCADERISTA:
                if (usuario && usuario.nombreRol == global.GUARDS.TELEMERCADERISTA) {
                    return true;
                }
                if (usuario && (usuario.nombreRol == global.GUARDS.LOGISTICA
                    || usuario.nombreRol == global.GUARDS.AUXILIAR_ADMINISTRATIVO_FACTURACION
                    || usuario.nombreRol == global.GUARDS.AUXILIAR_FACTURACION_CEDI
                    || usuario.nombreRol == global.GUARDS.AUXILIAR_ADMINISTRATIVO_CEDI)) {
                    return true;
                }
                if (usuario && usuario.nombreRol == global.GUARDS.VALIDADOR) {
                    return true;
                }
                break;
            case global.GUARDS.LOGISTICA:
                if (usuario && (usuario.nombreRol == global.GUARDS.LOGISTICA
                    || usuario.nombreRol == global.GUARDS.AUXILIAR_ADMINISTRATIVO_FACTURACION
                    || usuario.nombreRol == global.GUARDS.AUXILIAR_FACTURACION_CEDI
                    || usuario.nombreRol == global.GUARDS.AUXILIAR_ADMINISTRATIVO_CEDI)) {
                    return true;
                }
                break;
            case global.GUARDS.FACTURADOR:
                if (usuario && usuario.nombreRol == global.GUARDS.FACTURADOR) {
                    return true;
                }
                break;
            case global.GUARDS.AUTORIZADOR:
                if (usuario && usuario.nombreRol == global.GUARDS.AUTORIZADOR) {
                    return true;
                }
                break;
            case global.GUARDS.ADMINISTRADOR:
                if (usuario && usuario.nombreRol == global.GUARDS.ADMINISTRADOR) {
                    return true;
                }
                break;
            case global.GUARDS.VALIDADOR:
                if (usuario && usuario.nombreRol == global.GUARDS.VALIDADOR) {
                    return true;
                }
                break;
            //Opciones
            case global.GUARDS.CLIENTE:
                cliente = this.localStorageService.get(global.SESSION_ITEMS.CLIENTE);
                if (cliente) {
                    return true;
                }
                else {
                    this.router.navigate(['/rutero']);
                    return false;
                }
            case global.GUARDS.PEDIDO_FACTURADOR:
                pedido = this.localStorageService.get(global.SESSION_ITEMS.CLIENTE);
                if (pedido) {
                    return true;
                }
                else {
                    this.router.navigate(['/facturador']);
                    return false;
                }
        }
        this.redirectToHome(usuario ? usuario.nombreRol : null);
        return false;
    };
    AuthGuard.prototype.redirectToHome = function (rol) {
        switch (rol) {
            case null:
                this.router.navigate(['/auth/login']);
                break;
            case global.GUARDS.VENDEDOR:
                this.router.navigate(['/tablero']);
                break;
            case global.GUARDS.TELEMERCADERISTA:
                this.router.navigate(['/telemercaderista']);
                break;
            case global.GUARDS.LOGISTICA:
                this.router.navigate(['/ordenRecoleccionNc']);
                break;
            case global.GUARDS.AUXILIAR_ADMINISTRATIVO_FACTURACION:
                this.router.navigate(['/ordenRecoleccionNc']);
                break;
            case global.GUARDS.AUXILIAR_FACTURACION_CEDI:
                this.router.navigate(['/ordenRecoleccionNc']);
                break;
            case global.GUARDS.AUXILIAR_ADMINISTRATIVO_CEDI:
                this.router.navigate(['/ordenRecoleccionNc']);
                break;
            case global.GUARDS.FACTURADOR:
                this.router.navigate(['/facturador']);
                break;
            case global.GUARDS.AUTORIZADOR:
                this.router.navigate(['/autorizador']);
                break;
            case global.GUARDS.ADMINISTRADOR:
                this.router.navigate(['/gestion-autorizador']);
                break;
            case global.GUARDS.VALIDADOR:
                this.router.navigate(['/telemercaderista']);
                break;
            default:
                break;
        }
    };
    AuthGuard.ngInjectableDef = i0.defineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.inject(i1.AuthService), i0.inject(i2.LocalStorageService), i0.inject(i3.Router)); }, token: AuthGuard, providedIn: "root" });
    return AuthGuard;
}());
export { AuthGuard };
